export const conceptGroupsMessagesEn = {
  // Breadcrumbs
  'conceptGroups.breadcrumbs.conceptGroups': 'Concept groups',

  // Page Title
  'conceptGroups.pageTitle': 'Concept groups',

  // Column Headers
  'conceptGroups.columns.omopConceptGroupId': 'OMOP concept group ID',
  'conceptGroups.columns.conceptGroupName': 'Name',
  'conceptGroups.columns.domains': 'Domains',
  'conceptGroups.columns.conceptCount': 'Concept count',
  'conceptGroups.columns.owner': 'Owner',
  'conceptGroups.columns.modifiedDate': 'Modified on',

  // Actions
  'conceptGroups.actions.createConceptGroup': 'Create concept group',
};

export default conceptGroupsMessagesEn;
